// @flow

import React, { useContext } from 'react';
import Glyphicon from 'react-bootstrap/lib/Glyphicon';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';

import type { CommonActionProps } from './types.actions';
import type { GridItem } from '../../types';
import ToggleController from '../../controllers/ToggleController';
import ButtonAction from './ButtonAction';
import Subtitle from '../Subtitle';
import ItemFullHistoryModule from '../../modules/itemFullHistory';
import { ActionsContext } from '../../context/actions.context';
import { DesktopView, MobileView } from '../../config/mediaQuery';

type Props = {
  item: GridItem,
};

const ItemFullHistoryAction = (props: CommonActionProps & Props) => {
  const { setFullScreenView, allScreens } = useContext(ActionsContext);

  const moduleRenderer =                   
    <ItemFullHistoryModule
      isFullPage={false}
      selectedRow={props.item}
      size={'small'}
    />
  return (
    <ToggleController>
      {({ onToggleVisibility, visible }) => (
        <React.Fragment>
          <DesktopView>
            <ButtonAction
              bsSize={props.size}
              disabled={props.disabled}
              onClick={onToggleVisibility}
            >
              <Glyphicon glyph="time" /> View Full Item History
            </ButtonAction>
          </DesktopView>
          <MobileView>
            <button 
              disabled={props.disabled}
              onClick={onToggleVisibility}
            >
              <img src='assets/history.svg' alt='full item history'/> View Full Item History
            </button>
          </MobileView>
          <DesktopView>
            <Modal show={visible} onHide={onToggleVisibility}>
              <Modal.Header closeButton>
                <Modal.Title>
                  Item Full History{' '}
                  {props &&
                    props.item &&
                    props.item.AcctName &&
                    `- ${props.item.AcctName}`}{' '}
                </Modal.Title>
                <Subtitle>{props && props.item && props.item.Description}</Subtitle>
              </Modal.Header>
              <Modal.Body>
                {visible && (
                  moduleRenderer
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button onClick={onToggleVisibility}>Close</Button>
              </Modal.Footer>
            </Modal>
          </DesktopView>
          <MobileView>
            {setFullScreenView && !allScreens.find(o => o.view === moduleRenderer) && setFullScreenView(visible ? moduleRenderer : null, 'Item Full History', onToggleVisibility)}
          </MobileView>
        </React.Fragment>
      )}
    </ToggleController>
  )
}

ItemFullHistoryAction.defaultProps = {
  size: 'xsmall',
};

export default ItemFullHistoryAction;
